import script from "./AsesoriaImpositivaView.vue?vue&type=script&setup=true&lang=js"
export * from "./AsesoriaImpositivaView.vue?vue&type=script&setup=true&lang=js"

import "./AsesoriaImpositivaView.vue?vue&type=style&index=0&id=897cb5ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-897cb5ac"]])

export default __exports__